import {
  Avatar,
  Badge,
  Box,
  IconButton,
  Popover,
  Stack,
  Typography
} from "@mui/material";
import {
  CameraIcon,
  DotsThreeVertical,
  Envelope,
  Phone,
  Trash
} from "@phosphor-icons/react";
import ChurchPhoto from "assets/images/Photo.png";
import { IMAGE_URL } from "config";
import { useUpdateDenominationChurch } from "features/denominations";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useCentralStore } from "stores";
import { useUpdateChurch } from "../api";

export const ProfileHeader = ({ church, isDenominationChurch = false }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [photo, setPhoto] = useState();

  const churchUpdateMutation = isDenominationChurch
    ? useUpdateDenominationChurch()
    : useUpdateChurch();
  const open = Boolean(anchorEl);

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleChange = event => {
    const formData = new FormData();
    const fileUploaded = event.target.files[0];
    formData.append("image", fileUploaded);
    setPhoto(fileUploaded);
    churchUpdateMutation.mutate({
      churchData: formData,
      churchId: church?.id,
      denominationId: isDenominationChurch ? church?.denomination_id : null
    });
  };

  return (
    <>
      <Box sx={{ position: "relative", height: "290px", width: "100%" }}>
        <Box
          sx={{
            height: "184px",
            width: "100%",
            backgroundImage: `url(${ChurchPhoto})`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            backgroundPosition: "100% 60%",
            borderRadius: "20px",
            color: "white",
            position: "relative"
          }}
        >
          <IconButton
            onClick={handleClick}
            sx={{
              position: "absolute",
              top: "16px",
              right: "16px",
              color: "white"
            }}
          >
            <DotsThreeVertical />
          </IconButton>
        </Box>

        <Badge
          overlap="circular"
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right"
          }}
          badgeContent={
            <Avatar
              color="neutral"
              aria-label="upload picture"
              component="label"
              sx={{
                backgroundColor: "primary.main",
                color: "white",
                cursor: "pointer"
              }}
            >
              <input
                hidden
                accept="image/*"
                type="file"
                onChange={handleChange}
              />
              <CameraIcon />
            </Avatar>
          }
          sx={{
            position: "absolute",
            bottom: "0px",
            left: "50px",
            gap: "23px"
          }}
        >
          <Avatar
            src={
              photo
                ? URL.createObjectURL(photo)
                : `${IMAGE_URL}/${church?.image_url}`
            }
            alt={church?.name}
            sx={{
              width: "191px",
              height: "191px",
              border: theme => `4px solid ${theme.palette.primary.main}`
            }}
          />
        </Badge>

        <Stack
          sx={{
            gap: "10px",
            marginTop: "16px",
            marginLeft: "263px"
          }}
        >
          <Typography variant="h6" fontWeight={700}>
            {church?.name}
          </Typography>
          <Stack sx={{ gap: "8px" }}>
            {church?.phone && (
              <Stack direction="row" alignItems="center" spacing={1}>
                <Phone size={16} color="#a0aec1" />
                <Typography variant="body2" fontWeight={500}>
                  {church?.phone}
                </Typography>
              </Stack>
            )}
            {church?.email && (
              <Stack direction="row" alignItems="center" spacing={1}>
                <Envelope size={16} color="#a0aec1" />
                <Typography variant="body2" fontWeight={500}>
                  {church?.email}
                </Typography>
              </Stack>
            )}
          </Stack>
        </Stack>
      </Box>

      <Popover
        anchorEl={anchorEl}
        id="photo-menu"
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
        PaperProps={{
          elevation: 2
        }}
      >
        <ChurchMenu />
      </Popover>
    </>
  );
};

const ChurchMenu = () => {
  const openDeleteModal = useCentralStore(state => state.openDeleteModal);

  const { t } = useTranslation();

  return (
    <Stack
      sx={{
        backgroundColor: "white",
        p: 1
      }}
    >
      <Stack
        direction="row"
        spacing={1}
        alignItems="center"
        sx={{
          py: 1,
          px: 2,
          cursor: "pointer",
          color: "#F44949",
          "&:hover": {
            backgroundColor: "#FCD1D1"
          }
        }}
        onClick={openDeleteModal}
      >
        <Trash size={16} />
        <Typography variant="caption">{t("form.common.delete")}</Typography>
      </Stack>
    </Stack>
  );
};
